// Owns the report dialog's open/close lifecycle. Browsers retain returnValue
// across opens, including when the next close is Escape, so each open begins
// with no action selected.
export function bindReportDialog(
  open: EventTarget,
  dialog: Readonly<ReportDialog>,
  comment: Readonly<ReportComment>,
  report: (text: string) => Promise<boolean>,
): void {
  open.addEventListener('click', () => {
    Reflect.set(dialog, 'returnValue', '');
    dialog.showModal();
  });
  dialog.addEventListener('keydown', (event) => {
    if (event instanceof KeyboardEvent && event.key === 'Escape') event.stopPropagation();
  });
  dialog.addEventListener('close', () => {
    if (dialog.returnValue !== 'send') {
      Reflect.set(comment, 'value', '');
      return;
    }
    const draft = comment.value;
    void report(draft).then((sent) => {
      if (sent && comment.value === draft) Reflect.set(comment, 'value', '');
      return sent;
    });
  });
}
export interface ReportDialog extends Pick<EventTarget, 'addEventListener'> {
  readonly returnValue: string;
  showModal(): void;
}

export interface ReportComment {
  readonly value: string;
}
